export enum EntryFormStatusEnum {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  IN_REVIEW = 'IN_REVIEW',
  WAITING = 'WAITING',
  APPROVED = 'APPROVED',
  CLOSED_WITHOUT_APPROVAL = 'CLOSED_WITHOUT_APPROVAL',
}
